import { Paper, styled } from '@material-ui/core'

export const WhiteContainer = styled(Paper)({
  position: 'relative',
  padding: '20px',
  marginTop: '-3px',
  zIndex: 2,
  // backgroundColor: '#c7b45c', //galina is ok with white
})
